import type { EnumValueMeta } from '@joyful/utils'
import { createEnumSchema } from '@joyful/utils'
import type { LucideIcon } from 'lucide-react'
import {
  ArrowDownLeftIcon,
  ArrowDownRightIcon,
  ArrowUpLeftIcon,
  ArrowUpRightIcon,
} from 'lucide-react'

import type { Corner } from './CornerLayoutContext'

interface CornerPositionMeta extends EnumValueMeta {
  expandIcon: LucideIcon
  indicatorOffset: { x: number; y: number }
  minimizeIcon: LucideIcon
}

export type LeftCorner = Extract<Corner, 'bottom-left' | 'top-left'>

export const LeftCornerPositionSchema = createEnumSchema<
  LeftCorner,
  CornerPositionMeta
>([
  {
    expandIcon: ArrowUpRightIcon,
    indicatorOffset: { x: 3, y: 12 },
    minimizeIcon: ArrowDownLeftIcon,
    title: 'Bottom left',
    value: 'bottom-left',
  },
  {
    expandIcon: ArrowDownRightIcon,
    indicatorOffset: { x: 3, y: 7 },
    minimizeIcon: ArrowUpLeftIcon,
    title: 'Top left',
    value: 'top-left',
  },
])

export const CornerPositionSchema = createEnumSchema<
  Corner,
  CornerPositionMeta
>([
  ...LeftCornerPositionSchema.definitions,
  {
    expandIcon: ArrowUpLeftIcon,
    indicatorOffset: { x: 16, y: 12 },
    minimizeIcon: ArrowDownRightIcon,
    title: 'Bottom right',
    value: 'bottom-right',
  },
  {
    expandIcon: ArrowDownLeftIcon,
    indicatorOffset: { x: 16, y: 7 },
    minimizeIcon: ArrowUpRightIcon,
    title: 'Top right',
    value: 'top-right',
  },
])

export type CornerPositionDefinition =
  (typeof CornerPositionSchema.definitions)[number]
